import {
  Module, VuexModule, getModule, Mutation, Action,
} from '@compassdigital/vuex-module-decorators';
import { Notification, NotificationsApi } from '@compassdigital/foodworks.ts.sdk';
import store from '@/store';
import AppModule from '@/store/modules/app';

interface INotificationModule {
  notifications: Notification[];
  intervalRef: number | null,
}
@Module({
  dynamic: true,
  name: 'notification',
  namespaced: true,
  store,
})
class NotificationModule extends VuexModule implements INotificationModule {
  public notifications: Notification[] = [];

  public notificationIds: Set<string> = new Set<string>()

  public intervalRef: number | null = null

  @Mutation
  public SET_NOTIFICATIONS(notifications: Notification[]) {
    // this.notifications.length = 0
    notifications.forEach((n) => {
      if (!this.notificationIds.has(n.id as string)) {
        this.notifications.push(n);
        this.notificationIds.add(n.id as string);
      }
    });
  }

  @Mutation
  public UPDATE_READ_ID(notificationId: string) {
    const noti = this.notifications.find(n => n.id === notificationId);
    if (noti) { noti.read = true; }
  }

  @Mutation
  public UPDATE_UNREAD_ID(notificationId: string) {
    const noti = this.notifications.find(n => n.id === notificationId);
    if (noti) { noti.read = false; }
  }

  @Mutation
  public UPDATE_READ_ALL() {
    this.notifications.forEach(n => {
      // eslint-disable-next-line no-param-reassign
      n.read = true;
    });
  }

  @Mutation
  public SET_INTERVAL_REF(num: number) {
    this.intervalRef = num;
  }

  get unreadCount() {
    if (!this.notifications) return 0;
    return this.notifications.filter(n => n.read === false).length;
  }

  @Action
  public async startNotificationFetch() {
    const ref = setInterval(() => {
      this.fetchNotifications();
    }, 19000);
    this.SET_INTERVAL_REF(ref);
  }

  @Action
  public async stopNotificationFetch() {
    clearInterval(this.intervalRef as number);
  }


  /**
   *
   */
  @Action
  public async fetchNotifications() {
    const api = new NotificationsApi(AppModule.apiConfig);
    const notifications = await api.getNotifications();
    notifications.data.sort((a, b) => -(a.createdAt as string)
      .localeCompare(b.createdAt as string));
    this.SET_NOTIFICATIONS(notifications.data);
  }
}

export default getModule(NotificationModule);
